<template>
    <b-container class="modal-container">
        <div class="x-container" @click="hideModal">
            <img class="x-img" src="./../assets/x.svg" />
        </div>
        <b-row class="first-row">
            <b-col>
                <h4 v-if="paziente" class="title-item">{{paziente.nome + ' ' + paziente.cognome}}</h4>
                <h1 class="title-item"> {{nomePratica}} </h1>
                <!-- <img class="save-img title-item" src="./../assets/save.svg" /> -->
            </b-col>
            <b-col>
                <p class="body-item"><small>Data dichiarazione:</small> {{format_date(dataDichiarazione)}}</p>
                <p class="body-item"><small>Nome laboratorio:</small> {{nomeLaboratorio}}</p>
                <p class="body-item"><small>Data prescrizione:</small> {{format_date(dataPrescrizione)}}</p>
                <p class="body-item"><small>Numero prescrizione:</small> {{numeroPrescrizione}}</p>
            </b-col>
        </b-row>
        <hr>
        <b-row class="second-row">
            <div class="pdf-container">
                <p>Dichiarazione</p>
                <iframe :src="dichiarazione" type="application/pdf" width="100%" height="600px" style="overflow: auto;">
                </iframe>
            </div>
        </b-row>
        <b-row v-if="scheda_tecnica" class="second-row">
            <div class="pdf-container">
                <p>Scheda tecnica</p>
                <iframe :src="scheda_tecnica" type="application/pdf" width="100%" height="600px" style="overflow: auto;">
                </iframe>
            </div>
        </b-row>
    </b-container>
</template>

<script>
import { mixins } from "@/mixins";

export default {
    name: "CertificazioneDetails",
    data (){
        return {
            nomePratica: String,
            dataDichiarazione: null,
            nomeLaboratorio: String,
            dataPrescrizione: null,
            numeroPrescrizione: Number,
            dichiarazione: null,
            scheda_tecnica: null,
        }
    },
    props: {
        certificazione: Object,
        paziente: Object
    },
    mixins: [mixins],
    created(){
        this.getCertificazione(this.certificazione);
        this.getSchedaTecnica(this.certificazione);
        this.getCertificazioneData(this.certificazione)
        this.nomePratica = this.certificazione.nome;
        this.dataDichiarazione = this.certificazione.data_certificazione;
    },
    methods:{
        getCertificazione: function(certificazione){
            this.$axios
            .get(this.$apibase + '/api/certificazioni/get_dichiarazione',
                {
                    responseType: 'arraybuffer',
                    headers:{
                        Authorization:"JWT " + localStorage.getItem('access_token')
                    },
                    params: {
                        certificazione: certificazione.uid
                    }
                }
            )
            .then((response) => {
                let blob = new Blob([response.data], { type: 'application/pdf' });
                this.dichiarazione = window.URL.createObjectURL(blob);
            })
            .catch((e)=>{
                if (e.response.status == 403)
                    this.logout();
                else
                    alert(e);
            })
        },
        getSchedaTecnica: function(certificazione){
            this.$axios
            .get(this.$apibase + '/api/certificazioni/get_scheda_tecnica/',
                {
                    responseType: 'arraybuffer',
                    headers:{
                        Authorization:"JWT " + localStorage.getItem('access_token')
                    },
                    params: {
                        certificazione: certificazione.uid
                    }
                }
            )
            .then((response) => {
                    let blob = new Blob([response.data], { type: 'application/pdf' });
                    this.scheda_tecnica = window.URL.createObjectURL(blob);
            })
            .catch(e => {
                if (e.response.status == 404){
                    return;
                }
                if (e.response.status == 403)
                    this.logout();
                else
                    alert(e);
            })
        },
        getCertificazioneData: function(certificazione){
            this.$axios
            .get(this.$apibase + '/api/certificazioni/get_certificazione_metadata/',
                {
                    headers:{
                        Authorization:"JWT " + localStorage.getItem('access_token')
                    },
                    params: {
                        certificazione: certificazione.uid
                    }
                }
            )
            .then((response) => {
                this.dataPrescrizione = response.data.dataPrescrizione;
                this.numeroPrescrizione = response.data.numeroPrescrizione;
                this.nomeLaboratorio = response.data.nomeLaboratorio;
            })
            .catch((e) => {
                if (e.response.status == 403)
                    this.logout();
                else
                    alert(e);
            })
        },
        hideModal: function(){
            this.$emit('closeModal');
        }
    }
}
</script>

<style scoped>
    .pdf-container{
        width: 100%;
    }
    .modal-container{
        width: 100% !important;
        max-width: none !important;
        padding: 40px;
        display: inline-block;
    }
    h4, small {
        color: #707070;
    }
    .x-img{
        width: 15px;
    }
    .save-img{
        width: 25px;
    }
    .x-container{
        text-align: right;
        margin-bottom: 20px;
        padding-right: 30px;
        cursor: pointer;
    }
    .title-item{
        margin-bottom: 23px;
    }
    .body-item{
        margin-bottom:20px;
    }
    .first-row{
        margin-bottom: 40px;
    }
    .second-row{
        padding-top: 30px;
    }
</style>